import Vue from 'vue'
import App from './App.vue'
import router from './router'
import Element from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import axios from 'axios'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
Vue.use(VueAwesomeSwiper)

Vue.config.productionTip = false
Vue.use(Element);
Vue.prototype.$http = axios;
// axios.defaults.baseURL = 'http://test.api.chenyu.xiaoxxx.com/';
axios.defaults.baseURL = 'https://api.treegroup-inc.com/';
new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
